import{useContext as t}from"../../external/preact/hooks/dist/hooks.js";import{SRPanelContext as o}from"./SRPanelContext.js";function e(){return t(o)}export{e as default};
//# sourceMappingURL=useSRPanelContext.js.map
